import { normalizeApiError } from '@/lib/errors/normalizeApiErrorBody'
import { uploadChatDocument } from '@/services/documents/chatDocumentsApi'

/**
 * Upload one attachment and mark it ready.
 *
 * Ready means *saved*, not *parsed*. The documents service stores the file and
 * leaves it `uploaded`; only an explicit prepare starts parsing, and that is
 * issued by `query_documents` once a submitted question actually needs the
 * text. Waiting here for `completed` waited on work nobody had asked for — a
 * status GET does not advance the pipeline — so it blocked Send until the poll
 * gave up ten minutes later.
 *
 * Resolves with the document id; throws only on abort, which the caller treats
 * as a cancellation rather than a failure.
 */
export async function runAttachmentUpload({ file, chatId, idempotencyKey, projectId, signal, onState }) {
  onState({ uploadState: 'uploading', uploadError: null })
  if (!chatId) {
    onState({ uploadState: 'error', uploadError: 'Could not start a chat for this file' })
    return null
  }
  let doc
  try {
    doc = await uploadChatDocument(file, { chatId, idempotencyKey, projectId, signal })
  } catch (error) {
    if (signal?.aborted) throw error
    onState({ uploadState: 'error', uploadError: normalizeApiError(error).message })
    return null
  }
  if (!doc?.id) {
    onState({ uploadState: 'error', uploadError: 'Upload did not complete' })
    return null
  }

  onState({ documentId: doc.id, uploadState: 'ready', uploadError: null })
  return doc.id
}
